import useSWR, { KeyedMutator } from "swr";
import { getTemplates } from "../services/template-service";
import { TemplateInformation, TemplatesResponse } from "../types/api-types";

export interface UseTemplatesReturn {
  templates: TemplateInformation[] | undefined;
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<TemplatesResponse>;
}

/**
 * Custom hook to fetch and cache templates data.
 * Templates are fetched once and cached for the lifetime of the page.
 */
const useTemplates = (): UseTemplatesReturn => {
  const { data, error, mutate } = useSWR("/cleaning/templates", getTemplates);

  return {
    templates: data?.results,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useTemplates;
